const galleryItems = document.querySelectorAll('.fr-gallery-list-item');
const tagItems = document.querySelectorAll('.fr-tag-list-item');
const tagALL = document.querySelector('.fr-tag-list-all').textContent;
const modalCloses = document.querySelectorAll('.fr-gallery-modal-close');
const Modals = document.querySelectorAll('.fr-gallery-modal');
const modalBg = document.querySelector('.fr-gallery-modalbg');
// ======== ギャラリー追加コード（画像51個以上対応） ========
const galleryContainers = document.querySelectorAll('.fr-gallery-container');


// -------------------------------------------------
// ======== ギャラリー画像のアニメーション初期化 ========
// 　　　　　　　　　絞り込み時にもアニメーションが適用されるための処置
// -------------------------------------------------
galleryContainers.forEach(function (gcontainer) {
  gcontainer.addEventListener('animationend', function () {
    // 絞り込み時にもアニメーションが実行されるよう、アニメーションクラスを一旦削除
    gcontainer.classList.remove('fr-fadeIn');
  });
});

// -------------------------------------------------
// ======== 絞り込みに関する動き ========
// -------------------------------------------------
for (let j = 0; j < tagItems.length; j++) {

  // 絞り込みワードがクリックされた場合に行う処理
  tagItems[j].addEventListener('click', () => {

    // タグがクリックされたら、下線を非表示にする
    const activeItem = document.querySelectorAll('.fr-is-active');
    activeItem.forEach(function (tag) {
      tag.classList.remove('fr-is-active');
    });
    // クリックされたタグには下線を表示する
    tagItems[j].classList.add('fr-is-active');

    // 画像51個以上対応（ここから）
    galleryContainers.forEach(function (gcontainer) {
      gcontainer.classList.add('fr-hidden');
      if (tagItems[j].textContent == tagALL) {
        gcontainer.classList.remove('fr-hidden');
        gcontainer.classList.add('fr-fadeIn');
      } else if (gcontainer.classList.contains(tagItems[j].textContent)) {
        gcontainer.classList.remove('fr-hidden');
        gcontainer.classList.add('fr-fadeIn');
      } else {
        gcontainer.classList.add('fr-hidden');
      }
    }
    );
  });
}


// -------------------------------------------------
// ======== モーダル表示 ========
// -------------------------------------------------

//スライダーの初期化
const frelms = document.getElementsByClassName('splide',
  {
    pagination: boolean = true,
  }
);

var splideInstances = []; 
for (var i = 0; i < frelms.length; i++) {
  // new Splide(frelms[i]).mount();
  var splideInstance = new Splide(frelms[i]).mount(); // Splideインスタンスを作成
  splideInstances.push(splideInstance); // 作成したインスタンスを配列に追加
}



// 画像がクリックされたら、モーダルを表示する
for (let i = 0; i < galleryItems.length; i++) {
  galleryItems[i].querySelector('.fr-gallery-list-item-img').addEventListener('click', () => {

    // マスクの表示（背景を暗くする）
    if (modalBg.textContent == null) {
      modalBg.textContent = ' ';  // テキスト部分が空の場合、Shopifyではマスクが表示されないため
    }
    modalBg.style.visibility = 'visible';
    modalBg.animate({ opacity: [0, 1] }, 500);
    Modals[i].classList.remove('fr-hidden');
    Modals[i].animate({ opacity: [0, 1] }, 500);
  });
}

// モーダル背景がクリックされたら、背景とモーダルを非表示にする
modalBg.addEventListener('click', closeModalWindow);
modalCloses.forEach(function (modalClose) {
  modalClose.addEventListener('click', closeModalWindow);
});


function closeModalWindow() {
  modalBg.style.visibility = 'hidden';
  Modals.forEach(function (modal) {
    modal.classList.add('fr-hidden');
  });

  for (var i = 0; i < frelms.length; i++) {
    splideInstances[i].go(0);
  }



}